import React, { Component } from 'react'

interface DecimalInputProps {
    name?: string;
    value: number;
    label?: string;
    errorMessage?: string;
    placeholder?: string;
    disabled?: boolean;
    currency?: boolean;
    onChange?: (value: number, name?: string) => void;
}

interface DecimalInputState {
    value: string;
}

class DecimalInput extends Component<DecimalInputProps, DecimalInputState> {

    constructor(props: DecimalInputProps) {
        super(props);
        let n = props.value;
        if (this.props.currency) {
            n = n / 100;
        }
        this.state = {
            value: this.formatFloat(n)
        };
    }

    private strip = (s: string): string => {
        let result = '';
        let sawDecimal = false;
        for (let i = 0; i < s.length; i++) {
            const c = s[i];
            if (c >= '0' && c <= '9') {
                result += c;
            } else if (c === '.' && !sawDecimal) {
                result += c;
                sawDecimal = true;
            }
        }
        return result;
    }

    private parseFloat(s: string): number {
        if (!s) {
            return 0;
        }
        s = this.strip(s);
        s = s.replace(/\.$/g, '');
        return parseFloat(s);
    }

    private formatFloat(n: number): string {
        if (this.props.currency) {
            return n.toFixed(2);
        }
        return n.toString();
    }

    private handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let s = this.strip(e.target.value);
        this.setState({ value: s });
        if (this.props.onChange) {
            let n = this.parseFloat(s);
            if (this.props.currency) {
                n = Math.round(n * 100);
            }
            this.props.onChange(n, this.props.name);
        }
    }

    render() {
        const name = this.props.name || '';
        const placeholder = this.props.placeholder || '';
        const disabled = !!this.props.disabled;
        const id = Math.random().toString(36).substring(2);
        let label = <></>;

        if (this.props.label) {
            label = <label htmlFor={id} className={"label" + (this.props.errorMessage ? " is-danger" : "")}>{this.props.label}</label>;
        }
        return (
            <div className="field">
                {label}
                <div className="control">
                    <input className={"input" + (this.props.errorMessage ? " is-danger" : "")}
                        id={id}
                        name={name}
                        type="text"
                        placeholder={placeholder}
                        disabled={disabled}
                        value={this.state.value}
                        onChange={this.handleInputChange} />
                </div>
                {
                    this.props.errorMessage && <p className="help is-danger">{this.props.errorMessage}</p>
                }
            </div>
        );
    }
}

export default DecimalInput;
